import { Building2 } from "lucide-react";
import { useApi } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/kit";
import { HygieneRating } from "@/components/HygieneRating";

const tone = (s) => (s >= 85 ? "bg-emerald-500" : s >= 60 ? "bg-amber-500" : "bg-rose-500");

export default function VenueComparison() {
  const { user, venues, setVenueId } = useAuth();
  const enabled = user.tenant_role === "owner" && venues.length > 1;
  const { data } = useApi(enabled ? "/venues/compare" : null);
  if (!enabled || !data) return null;
  const rows = [...data].sort((a, b) => a.score - b.score);
  const weakest = rows[0];
  return (
    <Card data-testid="venue-comparison">
      <div className="mb-1 flex items-center gap-2"><Building2 className="h-4 w-4" /><h3 className="text-lg font-bold">Venue comparison</h3></div>
      <p className="mb-5 text-sm text-slate-500">Today's compliance score for each of your venues, weakest first.</p>
      <ul className="space-y-4">
        {rows.map((v) => (
          <li key={v.venue_id} data-testid={`venue-compare-${v.venue_id}`}>
            <button onClick={() => setVenueId(v.venue_id)} className="group w-full text-left">
              <div className="mb-1.5 flex flex-wrap items-baseline gap-2">
                <span className="font-semibold text-slate-900 group-hover:underline">{v.name}</span>
                {v.venue_id === weakest.venue_id && weakest.score < 85 && <span data-testid="venue-weakest-badge" className="rounded-full bg-rose-100 px-2 py-0.5 text-[11px] font-semibold text-rose-700">Needs attention</span>}
                <HygieneRating data={v.inspector_rating} compact testid={`venue-rating-${v.venue_id}`} />
                <span className="ml-auto font-display text-xl font-extrabold" data-testid={`venue-score-${v.venue_id}`}>{v.score}</span>
              </div>
              <div className="h-2.5 overflow-hidden rounded-full bg-slate-100"><div className={`h-full rounded-full ${tone(v.score)}`} style={{ width: `${v.score}%`, transition: "width .6s ease" }} /></div>
              <div className="mt-1.5 flex flex-wrap gap-x-4 gap-y-1 font-mono text-[11px] text-slate-500">
                <span>Checks {v.checks_done}/{v.checks_total}</span>
                <span className={v.overdue ? "text-rose-600" : ""}>Overdue {v.overdue}</span>
                <span className={v.open_incidents ? "text-amber-600" : ""}>Incidents {v.open_incidents}</span>
                <span className={v.out_of_range_7d ? "text-rose-600" : ""}>Out of range 7d {v.out_of_range_7d}</span>
                <span>Equipment issues {v.equipment_attention}</span>
              </div>
            </button>
          </li>
        ))}
      </ul>
    </Card>
  );
}
